<div class="content-inner">
    <div class="title-bar">
        <div class="container-fluid">
            <div class="row">
                <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
                    <div class="col-auto">
                        <h2 class="page-title">
                            Migration tool
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <form [formGroup]="formdata" name="formdata" (ngSubmit)="startMigration($event)" #ngForm="ngForm">
            <div class="my-3">
                <div class="row">
                    <div class="col-sm">
                        <div class="form-group">
                            <label for="enterUsername">{{ translationKeys.Authorization.Username | translate}}</label>
                            <input inputSanitizer type="text" class="form-control" id="enterUsername" name="username"
                                aria-describedby="emailHelp" maxlength="100"
                                placeholder="{{ translationKeys.Authorization.UsernamePlaceholder | translate}}"
                                required autofocus formControlName="username"
                                [ngClass]="{'is-invalid':formdata.get('username').errors && (formdata.get('username').touched || formdata.get('username').dirty) || ngForm.submitted}">
                            <div class="invalid-feedback"
                                *ngIf="formdata.get('username').errors && (formdata.get('username').touched || formdata.get('username').dirty) || ngForm.submitted">
                                <span *ngIf="formdata.get('username').errors?.required">
                                    {{translationKeys.ErrorMessages.RequiredUserName | translate}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-sm" [class.col-lg-6]="isDesktop"> -->
                    <div class="col-sm">
                        <div class="form-group">
                            <label for="enterPassword">{{ translationKeys.Authorization.Password | translate }}</label>
                            <div class="wrapper">
                                <input inputSanitizer [type]="showPassword ? 'text' : 'password'" class="form-control"
                                    maxlength="25" id="enterPassword" name="password"
                                    placeholder="{{ translationKeys.Authorization.PasswordPlaceholder | translate }}"
                                    required formControlName="password"
                                    [ngClass]="{'is-invalid':formdata.get('password').errors && (formdata.get('password').touched || formdata.get('password').dirty) || ngForm.submitted }">
                                <span class="viewPassword">
                                    <img [ngClass]="{'active':showPassword}"
                                        [src]="(showPassword)?'assets/ph-bhp-layout/svg/icon-view.svg':'assets/ph-bhp-layout/svg/eye-close.svg'"
                                        alt="view password" (click)="viewPassword()">
                                </span>
                                <div class="invalid-feedback"
                                    *ngIf="formdata.get('password').errors && (formdata.get('password').touched || formdata.get('password').dirty) || ngForm.submitted ">
                                    <span *ngIf="formdata.get('password').errors?.required">
                                        {{ translationKeys.ErrorMessages.RequiredPassword | translate }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-sm" [class.col-lg-6]="isDesktop"> -->
                    <div class="col-sm">    
                        <div class="form-group">
                            <label for="enterInstitutionId">{{ 'Institution or group ID' | translate}}</label>
                            <div>
                                <input inputSanitizer type="text" class="form-control" id="enterInstitutionId"
                                    name="institutionid" aria-describedby="emailHelp" maxlength="100"
                                    placeholder="{{ 'Numberic ID' | translate}}" required autofocus
                                    formControlName="institutionid"
                                    [ngClass]="{'is-invalid':formdata.get('institutionid').errors && (formdata.get('institutionid').touched || formdata.get('institutionid').dirty) || ngForm.submitted}">
                                <div class="invalid-feedback"
                                    *ngIf="formdata.get('institutionid').errors && (formdata.get('institutionid').touched || formdata.get('institutionid').dirty) || ngForm.submitted">
                                    <span *ngIf="formdata.get('institutionid').errors?.required">
                                        {{ 'Required institutionId' | translate}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-sm" [class.col-lg-6]="isDesktop"> -->
                    <div class="col-sm">
                        <button class="accept btn btn-primary" [disabled]="!formdata.valid">{{ 'CONFIGURE.ACCEPT'
                            | translate }}</button>
                    </div>
                </div>
            </div>
        </form>
        <div class="textAreaDiv">
            <div class="logsHeader">
                <p class="logLabel">Logs</p>
                <p class="migrationLabel">Migration id: {{migrationGuid}}</p>
            </div>
            <textarea #logs class="logTextArea" [(ngModel)]='textAreaLogs' readonly ></textarea>
        </div>
        <!-- <div class="logsFooter" [class.col-lg-6]="isDesktop"> -->
        <div class="logsFooter">
            <button class="download btn btn-primary" (click)="downloadLogs($event)" [disabled]="downloadDisabled">Download logs</button>
        </div>

    </div>
</div>